export default __webpack_public_path__ + "static/media/004-B-securite.7fa58daa.svg";